<template>
    <div class="npv-configuration-container">
        <tabs :tabs="tabs" :currentTab="currentTab" @update-current-tab="updateCurrentTab"/>
        <configuration-workspaces v-if="currentTab === 0"/>
        <configuration-buildings v-if="currentTab === 1"/>
        <configuration-forms v-if="currentTab === 2"/>
        <configuration-preview v-if="currentTab === 3" @cancel="cancel"/>
    </div>
</template>
  
<script>
    import { mapActions } from "vuex";
    import Tabs from "./components/Tabs.vue"
    import ConfigurationWorkspaces from "./views/ConfigurationWorkspaces.vue";
    import ConfigurationBuildings from "./views/ConfigurationBuildings.vue";
    import ConfigurationForms from "./views/ConfigurationForms.vue";
    import ConfigurationPreview from "./views/ConfigurationPreview.vue";
    export default {
        name: "ConfigurationNpv",
        components: {
            Tabs, 
            ConfigurationWorkspaces,
            ConfigurationBuildings,
            ConfigurationForms,
            ConfigurationPreview
        },

        data(){
            return {
                tabs: [
                    {
                        label: 'Workspaces',
                    },
                    {
                        label: 'Buildings',
                    },
                    {
                        label: 'Configuration',
                    },
                    {
                        label: 'Preview'
                    }
                ],
                currentTab: 0
            }
        },
    
        methods: {
            ...mapActions([
            ]),
            updateCurrentTab(newTab){
                this.currentTab = newTab;
            },
            cancel(){
                this.currentTab = 0;
            }
        }
    };
</script>
<style scoped>
  .npv-configuration-container {
    width: 100%;
    height: 100%;
    padding: 70px 20px 60px 40px;
  }
</style>
  


// WEBPACK FOOTER //
// src/components/Npv/Configuration/Npv.vue